module.exports = __webpack_public_path__ + "img/passwords.c8debb25.svg";